export const determineTenant = () => {
    return 'smithfield'; // TEMP for local testing — revert before commit
    // eslint-disable-next-line no-unreachable
    const host = window.location.hostname.toLowerCase();
    const isLocalHost = host === 'localhost' || host === '127.0.0.1' || host === '::1';

    if (host.indexOf('smithfield') >= 0) {
        return 'smithfield';
    }
    if (
        window.location.origin.toLowerCase().indexOf('investceo') >= 0 ||
        isLocalHost
    ) {
        return 'investceo';
    }
    return 'alm';
}
